import React, {useEffect, useState} from 'react';
import {Button, Checkbox, notification, Table} from 'antd';
import Axios from "../../config/axiosConfig/axios";
import {Api} from "../../config/apiList/api";
import {render} from "react-dom";


function separate(Number)
{
    Number+= '';
    Number= Number.replace(',', '');
    var x = Number.split('.');
    var y = x[0];
    var z= x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(y))
        y = y.replace(rgx, '$1' + ',' + '$2');
    return y+ z;
}

const SelectionTable = (props) => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [days, setDays] = useState(-1);
    const [price, setPrice] = useState(-1);
    const [api, setApi] = useState(false);



    const RedNotification = (text) => {
        notification.open({
            message: "اخطار",
            description: text,
            style: {
                background: "#F3585c",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }

    const GreenNotification = (text) => {
        notification.open({
            message: "موفقیت",
            description: text,
            style: {
                background: "#43a047",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }


    const start = async () => {
        await setLoading(true);
        // ajax request after empty completing



            const data = {
                days: days,
                price: price
            }


            if((days >= 0 || days === -1) && (price >= 0 || price === -1)) {
                await Axios.patch(`${Api}editSettings/${selectedRowKeys[0]}`, data
                )
                    .then(async (data) => {
                        if (data.statusCode === 200 || data.statusCode === 201) {
                            await notification.open({
                                message: "موفقیت",
                                description: "درخواست با موفقیت انجام شد!",
                                style: {
                                    background: "#43a047",
                                    color: "white",
                                    fontFamily: "IRANSansMobileFaNum",
                                    borderRadius: "5px",
                                }
                            })

                        } else {
                            RedNotification(data.message);
                        }

                    })
                    .catch((error) => {
                    });
            }


           await Axios.get(`${Api}getAllSettings`
            )
                .then((data) => {
                    if (data.statusCode === 200 || data.statusCode === 201) {
                        props.setSettingList(data.data.data);
                    }

                })
                .catch((error) => {
                });


        setTimeout(() => {
            setSelectedRowKeys([]);
            setLoading(false);
        }, 1000);
    };


    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    };

    const columns = [

        {
            title: 'شناسه',
            dataIndex: 'id',

        },
        // {
        //     title: 'کلید',
        //     dataIndex: 'key',
        //
        // },
        {
            title: 'عنوان',
            // dataIndex: 'validity',
            dataIndex: "title"

        },


        {
            title: 'روز',
            // dataIndex: 'validity',
            render:  (e) => {
                return e.key === selectedRowKeys[0] ? <input defaultValue={e.days} onLoad={() => {setDays(e.days)}} style={{borderRadius:"4px", width:"105px", textAlign: "center"}} type="number" min={0}
                    onChange={event => {
                        setDays(event.target.value);
                    }}


                    />

                    : <p>{e.days}</p>
            },

        },

        {
            title: 'قیمت(تومان)',
            // dataIndex: 'validity',
            render:  (e) => {
                return e.key === selectedRowKeys[0] ? <input onLoad={() => {setPrice(e.price)}} defaultValue={e.price} style={{borderRadius:"4px", width:"105px", textAlign: "center"}} type="number" min={0}
                                                             onChange={event => {
                                                                 setPrice(event.target.value);
                                                             }}


                /> : <p>{separate(e.price)}</p>
            },
        },


        // {
        //     title: 'کد فعالسازی',
        //     render: (e) => {return <div>
        //         <p style={{fontFamily: "arial"}}>{ "...."+ e.licence.substring(0,20)}</p>
        //         <Button onClick={async event => {
        //
        //
        //             await navigator.clipboard.writeText(e.licence);
        //             notification.open({
        //                 message: "انجام شد",
        //                 description: "کد فعالسازی کپی شد!",
        //                 style: {
        //                     background: "#43a047",
        //                     color: "white",
        //                     fontFamily: "IRANSansMobileFaNum",
        //                     borderRadius: "5px",
        //                 }
        //             })
        //
        //         }} style={{  backgroundColor: "white",
        //             color: "#3174ff",
        //             border: "2px solid #ffffff" /* Green */}}>کپی</Button>
        //     </div>}
        //     // dataIndex: 'licence',
        //
        // },
        // {
        //     title: 'عمليات',
        //     render: (e) => {
        //         return  <></>
        //
        //     }
        //
        // },
    ];

    const hasSelected = selectedRowKeys.length === 1;
    return (
        <div >

            <Table rowKey={record => record.key} rowSelection={rowSelection} columns={columns} dataSource={props.settingList} pagination={false} style={{marginBottom: "20px", fontFamily: "iranSansBold"}} />
            <div
                style={{
                    marginBottom: 16,
                }}
            >
                <Button type="primary" onClick={start} disabled={!hasSelected} loading={loading} style={{borderRadius: "5px", textAlign:"center", fontSize:"15px", fontFamily: "iranSansBold"}}>
                    ویرایش
                </Button>
                <span
                    style={{
                        marginLeft: 8,
                    }}
                >
        </span>
            </div>
        </div>
    );
};
export default SelectionTable;